export interface IServicesData {
    isFamilyVoucherParticipant: boolean,
    hasVoucherRestrictions: number,
    performsIncompatibleTransplants: number,
    performsDesensitization: number,
    performsNonSteroidProtocol: number,
    maxPairWorkups: string,
    minimumNddAge: string,
    maximumNddAge: string,
    maxBulkCheekSwabsWithin24Hours: string,
    providesDonorInsurance: number,
    livingDonorFullfillJobAsDonorNav: number,
    donorWorkupWait: string,
    recipientWorkupWait: string,
    hasAbPatients: number,
    // doesA2ChainEndOptimization: number,
    canUtilizeA2toBPatients: number,
    chainEndTarget: number
}